<template>
  <div>
    <el-form :inline="true">
      <el-form-item>
        <!-- dialogVisible = true -->
        <el-button type="primary" @click="changeEventRevenueClick">Add</el-button>
        <el-button type="primary" @click="batchDelClick">Delete</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="eventRevenueList"
      border
      stripe
      style="width:100%;"
      height="80vmin"
      highlight-current-row
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="EventName" prop="eventName" align="center"></el-table-column>
      <el-table-column label="Revenue" prop="revenue" align="center"> </el-table-column>
      <el-table-column label="Operator" prop="createBy" align="center"></el-table-column>
      <el-table-column label="Operate Time" prop="createTime" align="center"></el-table-column>
      <el-table-column label="Option" align="center" min-width="100">
        <template slot-scope="scope">
          <el-button type="primary" @click="changeEventRevenueClick(scope.row)">Update</el-button>
          <el-button type="danger" @click="delClick(scope.row.id)">Delete</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      class="block pagePanel"
      :pageTotal="eventRevenueTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :pageSize="pageSize"
      :currentPage="currentPage"
    ></pagination>

    <!-- 删除提示框 -->
    <el-dialog title="Delete" :visible.sync="delDialogVisible" width="300px" append-to-body>
      <div class="del-dialog-cnt">Confirm to delete ?</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delDialogVisible = false">cancel</el-button>
        <el-button type="primary" @click="delEventRevenue()">confirm</el-button>
      </span>
    </el-dialog>
    <!-- PB 配置模块框 -->
    <el-dialog
      :visible.sync="dialogVisible"
      title="Event Revenue"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <el-form
        :model="eventRevenue"
        label-position="left"
        label-width="95px"
        ref="eventRevenueForm"
        :rules="rules"
      >
        <el-row>
          <el-col :lg="11" :md="20">
            <el-form-item label="EventName" prop="eventName">
              <el-input v-model="eventRevenue.eventName" placeholder="eventName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="20" :offset="1">
            <el-form-item label="Revenue" prop="revenue">
              <el-input v-model="eventRevenue.revenue" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="changeEventRevenue()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Pagination from '@/components/pagination';

  import { getEventRevenueList, updateEventRevenue, deleteEventRevenue } from 'api/offer/detail';
  const defaultEventRevenue = {
    eventName: '',
    revenue: '',
  };
  export default {
    components: {
      Pagination,
    },
    props: {
      offerId: {
        type: [String, Number],
        required: true,
      },
    },
    data() {
      return {
        selectIds: [],
        eventRevenueTotal: null,
        currentPage: 1,
        pageSize: 20,
        delDialogVisible: false,
        eventRevenueList: [],
        rules: {
          eventName: [
            {
              required: true,
              message: 'eventName must be specified',
            },
          ],
          revenue: [
            {
              required: true,
              message: 'revenue must be specified',
            },
          ],
        },
        dialogVisible: false,
        eventRevenue: {},
      };
    },
    mounted() {
      this.getEventRevenueList();
    },
    methods: {
      getEventRevenueList(curPage) {
        if (curPage) {
          this.currentPage = curPage;
        }
        const param = {
          page: this.currentPage,
          pageSize: this.pageSize,
          offerId: this.offerId,
        };
        getEventRevenueList(param).then((response) => {
          if (response.code === 200) {
            this.eventRevenueList = response.result;
            this.eventRevenueTotal = response.total;
          }
        });
      },
      changeEventRevenueClick(row) {
        this.eventRevenue = Object.assign({}, defaultEventRevenue, row);
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.eventRevenueForm.clearValidate();
        });
      },
      batchDelClick() {
        const length = this.selectIds.length;
        if (length <= 0) {
          this.$message.warning('你还没有选择要删除的数据哦~');
          return;
        }
        this.delDialogVisible = true;
      },
      delClick(id) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.delEventRevenue(id);
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除',
            });
          });
      },
      delEventRevenue(id) {
        const ids = id ? id : this.selectIds.join(',');
        const params = {
          ids,
          offerId: this.offerId,
        };
        deleteEventRevenue(params).then((response) => {
          if (response.code === 200) {
            this.$message({
              message: 'Delete Success',
              type: 'success',
            });
            this.getEventRevenueList();
          } else {
            this.$message.error('Delete Error:' + response.message);
          }
        });
        this.delArr = [];
        this.delDialogVisible = false;
      },
      changeEventRevenue() {
        this.$refs.eventRevenueForm.validate((valid) => {
          if (valid) {
            let param = {
              ...this.eventRevenue,
              offerId: this.offerId,
            };
            const typeStr = param.id ? 'Update' : 'Add';
            updateEventRevenue(param).then((response) => {
              if (response.code === 200) {
                this.$message({
                  message: typeStr + ' Success',
                  type: 'success',
                });
                this.getEventRevenueList();
              } else {
                this.$message.error(typeStr + ' Error:' + response.message);
              }
            });
            this.dialogVisible = false;
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleSelectionChange(val) {
        this.selectIds = val.map((item) => item.id);
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.handleCurrentChange(1);
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getEventRevenueList();
      },
    },
  };
</script>

<style></style>
